<template lang="pug">
  v-dialog(v-model="showDialog")
    v-card
      v-card-title
        | Installa App
        v-spacer
        v-btn(icon @click='showDialog=false')
          v-icon mdi-close
            v-card-text
      v-card-text
        .text-center Aggiungi questa app alla schermata Home per un accesso piu' rapido e una miglior esperienza d'uso.
        .text-center.font-weight-bold.mt-1 Tocca <img class="mx-1" src="/ios.share.png" height="20rem"/> e poi 'Aggiungi a Home'
</template>

<script>
export default {
  name: "AddToHomeIOSSafariDialog",
  data() {
    return {
      showDialog: false
    };
  },
  mounted() {
    const ua = window.navigator.userAgent;
    const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    const webkit = !!ua.match(/WebKit/i);
    const iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
    this.showDialog =
      iOSSafari &&
      window.localStorage.getItem("AddToHomeIOSSafariDialog") == null;
    window.localStorage.setItem("AddToHomeIOSSafariDialog", "true");
  }
};
</script>
